import { useState } from 'react';
import type { MediaKitCard } from '../../lib/api/operatorConsole';
import { ImageLightbox } from '../../components/ui/ImageLightbox';
import { Pill } from '../../components/ui/Pill';
import { AssetDownloadButton } from './AssetDownloadButton';
import { PackArt } from './PackArt';
import { formatUsd } from './mediaKitFormat';

const PREVIEW = 'aspect-[5/7] w-full';

export function CardTile({ packId, card }: { packId: number; card: MediaKitCard }) {
  const [zoomed, setZoomed] = useState(false);
  const preview = card.assets[0]?.preview_url ?? null;
  const titleId = `media-kit-card-${card.id}`;

  return (
    <article
      aria-labelledby={titleId}
      className="flex flex-col overflow-hidden rounded-xl border border-[var(--co-border)] bg-[var(--co-surface)]"
    >
      {preview ? (
        <button
          type="button"
          onClick={() => setZoomed(true)}
          aria-label={`Preview ${card.title}`}
          className="cursor-zoom-in focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[var(--co-brand)]"
        >
          <PackArt src={preview} alt="" className={PREVIEW} />
        </button>
      ) : (
        <PackArt src={null} alt="" className={PREVIEW} />
      )}

      <div className="flex flex-1 flex-col gap-2 border-t border-[var(--co-border)] p-3">
        <h3 id={titleId} title={card.title} className="line-clamp-2 text-[13px] font-medium text-[var(--co-text)]">
          {card.title}
        </h3>
        <div className="flex flex-wrap items-center gap-2">
          <span className="font-mono text-[12px] text-[var(--co-text)]">{formatUsd(card.value)}</span>
          {card.tier && <Pill tone="brand">{card.tier}</Pill>}
        </div>
        <div className="mt-auto flex flex-col gap-1.5 pt-1">
          {card.assets.length === 0 ? (
            <p className="text-[12px] text-[var(--co-muted)]">No images for this card yet.</p>
          ) : (
            card.assets.map((asset) => (
              <AssetDownloadButton key={asset.id} packId={packId} asset={asset} owner={card.title} />
            ))
          )}
        </div>
      </div>

      {zoomed && preview ? (
        <ImageLightbox src={preview} title={card.title} onClose={() => setZoomed(false)} />
      ) : null}
    </article>
  );
}
